<template>
    <li class="dashboard-message">
        <div class="head">
            <div class="head-chat">
                <router-link :to="`/channel/${item.id}`" class="head-chat__avatar">
                    <img :src="item.icon | imgSrc" alt="">
                </router-link>
                <router-link :to="`/channel/${item.id}`" tag="h4" class="head-chat__chat-name">{{item.name}}</router-link>
            </div>

            <router-link :to="`/channel/${item.id}`" class="link link--whiteboard" v-if="item.unread_messages_count !== 0">
                <span class="link-whiteboard__image">
                   <img :src="env.public_base + '/assets/images/chat-icon.svg'" alt="">
                </span>
                <span>{{item.unread_messages_count}}
                    <span class="link-whiteboard__text">{{$t('new_messages')}}</span></span>
            </router-link>
        </div>

        <div class="body main-chat__item">
            <a href="javascript:void(0)" class="body__avatar">
                <img :src="sender.photo | imgSrc" alt="" v-if="sender.photo !== undefined && sender.photo !== null">
                <img class="item__profile-image"
                     :src="env.public_base + '/assets/images/person-icon.png'" alt=""
                     v-else>
            </a>

            <div class="item__content">

                <a href="javascript:void(0)">
                    <h4>{{sender.last_name}} {{sender.first_name}}</h4>
                </a>

                <p class="item-content__message" @paste="sanitize"
                   v-linkified:options="{ className: 'link' }"
                   v-html="item.last_message.text"
                >
                    {{item.last_message.text}}
                </p>

                <p v-if="attachment && attachment.path !== null && attachment.name !== null" class="attachment-file">
                    <a target="_blank" :href="env.s3_url + attachment.path">{{ attachment.name }}</a>
                </p>

                <span style="display: none;">{{item.last_message.updated}}</span>
                <p class="item-content__date">{{item.last_message.created | formatDateMmDdYyyy}}</p>
            </div>
        </div>
    </li>
</template>

<script>
    import {mapGetters} from 'vuex';
    import env from '../../env';

    export default {
        props: ['item'],
        data: function () {
            return {
                env,
            }
        },
        components: {

        },
        computed: {
            ...mapGetters([]),
            sender() {
                return this.item.last_message.sender
            },
            attachment() {
                return !!this.item.last_message.attachments.length ? this.item.last_message.attachments[0] : this.item.last_message.attachments[0]
            }
        },
        methods: {
            sanitize(event) {
                event.preventDefault();
                const html = this.$sanitize(event.clipboardData.getData('text/html'));
                document.execCommand('insertHTML', false, (html));
            },
        },


    }
</script>

